<!-- MenuTree.vue -->
<template>
  <el-submenu v-if="menu.children && menu.children.length>0" :index="menu.id+''">
    <template slot="title">
      <!-- <i :class="menu.icon"></i> -->
      <span>{{ menu.menuName }}</span>
    </template>
    <template v-for="child in menu.children">
      <menu-tree-mb :menu="child" :key="child.id"></menu-tree-mb>
    </template>
  </el-submenu>
  <el-menu-item v-else :index="menu.id+''">
    <!-- <i :class="menu.icon"></i> -->
    <span>{{ menu.menuName }}</span>
  </el-menu-item>
</template>

<script>
export default {
  name: 'MenuTreeMb',
  props: {
    menu: {
      type: Object,
      required: true
    }
  }
};
</script>

